import { gql } from '@apollo/client';
import UPDATE_CLASSROOM_SETTING_FRAGMENT from '../../fragments/update-classroom-setting-fragment';

const UPDATE_AZSAPP_CLASSROOM_EXPOSE_LETTER_BOOKS_SETTING = gql`
  mutation updateAzsappClassroomSettingExposeLetterBooks(
    $data: [UpdateAzsappClassroomSettingExposeLetterBooksInput!]!
  ) {
    updateAzsappClassroomSettingExposeLetterBooks(data: $data) {
      ...UpdateClassroomSettingFragment
    }
  }
  ${UPDATE_CLASSROOM_SETTING_FRAGMENT}
`;

export default UPDATE_AZSAPP_CLASSROOM_EXPOSE_LETTER_BOOKS_SETTING;
